import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../core/services/internal';

export function provideAuthentication(): EnvironmentProviders {
    return provideAppInitializer(() =>
        (
            (authService: AuthService) => (): Observable<boolean> =>
                authService.checkAuthenticatedOrLogin()
        )(inject(AuthService))()
    );
}
